import {gql} from '@apollo/client'

export const GET_ALL_USERS = gql`
  query listUsers(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $email: String
    $id: ID
  ) {
    listUsers(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      email: $email
      id: $id
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          firstName
          lastName
          isActive
          email
        }
      }
    }
  }
`

export const GET_ONE_USERS = gql`
  query listUsers($id: ID) {
    listUsers(id: $id) {
      edges {
        node {
          id
          firstName
          lastName
          isActive
          email
          lastLogin
          groups {
            edges {
              node {
                id
                name
              }
            }
          }
          currentRol {
            id
            name
          }
          inactivationDate
          identityvalidationSet {
            edges {
              node {
                id
                firstName
                secondName
                firstSurname
                secondSurname
                documentType
                documentNumber
                phoneNumber
                status
                expeditionDate
                created
              }
            }
          }
        }
      }
    }
  }
`
